<script setup lang="ts">
  import { onMounted, useTemplateRef } from 'vue'
  import TheModalConfirmPassword from '@/components/the-modal-confirm-password.vue'
  import TheToast from '@/components/the-toast.vue'
  import { useModalEscListener } from './components/modal'
  import { useInitApp } from './models/app'
  import { usePageStore } from './stores/page'

  const { init } = useInitApp()
  init()

  const page = usePageStore()
  const modalConfirmPassword = useTemplateRef('modalConfirmPassword')
  onMounted(() => {
    page.setModalConfirmPassword(modalConfirmPassword.value)
  })

  useModalEscListener()
</script>

<template>
  <div>
    <app-router-view />
  </div>
  <the-toast />
  <the-modal-confirm-password ref="modalConfirmPassword" />
</template>
